import React from 'react';
import ReactDOM from 'react-dom';
import Root from 'views/Root';

ReactDOM.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
  document.getElementById('root'),
);

// export NODE_OPTIONS=--openssl-legacy-provider